import type { LookupStatus } from '~components/LookupStatusBadge';

export type ContributionStatusTag = 'current' | 'future' | 'ended';

// Colours per plan: Current green, Future blue, Ended grey.
export const CONTRIBUTION_STATUS_BADGES: Record<ContributionStatusTag, LookupStatus> = {
  current: { tag: 'current', name: 'Current', colour: '198754' },
  future: { tag: 'future', name: 'Future', colour: '0D6EFD' },
  ended: { tag: 'ended', name: 'Ended', colour: '6C757D' },
};

// Dates are compared as `YYYY-MM-DD` strings, which sort chronologically. Anything longer (an ISO
// timestamp) is cut back to its date part first.
const toDay = (value?: string | null) => (value ? String(value).slice(0, 10) : '');

/**
 * Where a contribution sits relative to `today` (`YYYY-MM-DD`, the browser's local date).
 *
 * Future when it starts after today; Ended when it has an end date before today; Current
 * otherwise. Both boundaries are inclusive, and a missing end date is open ended. An end date
 * before the start date reads as Ended, since the end date is the earlier fact.
 */
export const getContributionStatus = (
  start_date: string | null | undefined,
  end_date: string | null | undefined,
  today: string,
): ContributionStatusTag => {
  const start = toDay(start_date);
  const end = toDay(end_date);

  if (start && start > today) return 'future';
  if (end && end < today) return 'ended';
  return 'current';
};
